/* eslint-disable custom/no-restricted-translation-jsx-untranslated-children-text */
import React from 'react';

import { Typography } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { Locale } from '@kamernet/core/Intl/types';

import styles from './Content.module.css';

interface ContentCityApartmentProps {
  cityName: string;
}

export const ContentCityApartment = ({
  cityName,
}: ContentCityApartmentProps) => {
  const { locale } = useIntl();

  return locale === Locale.en ? (
    <React.Fragment>
      <Typography
        variant="h1"
        className={styles.title}
      >{`Apartments & Flats for rent in ${cityName}, Netherlands`}</Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Looking to rent an apartment in ${cityName}? Kamernet has a wide range of verified rental apartments in ${cityName} available for you.
        Our database of apartment rentals in ${cityName} is freely available, just signup on Kamernet and make a booking for a rental that matches your budget and preference.
        Kamernet is a leading platform dedicated to helping tenants find their accommodation as easily and quickly as possible.
        If you're looking for a furnished apartment in ${cityName} that is ready to move, then use our advanced search features to narrow-down listings with specific features that you want.`}
      </Typography>
      <Typography variant="h3" component="h2" className={styles.title}>
        {`Finding apartments in ${cityName} as an expat`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`If you're an expat moving to ${cityName} from abroad, then start looking for rental apartments in ${cityName} at least a few months in advance.
        On Kamernet, you can easily find available apartments in ${cityName} tailored to your specific needs.
        Whether you're looking for 1 bedroom, 2 bedroom, semi-furnished, fully furnished, private, shared, long-term or short-term apartments in ${cityName}; Kamernet has got you covered.
        Our smart search filters ensure you find the perfect place in ${cityName} with all your desired amenities.`}
      </Typography>
      <Typography variant="h3" component="h2" className={styles.title}>
        {`Best website to find apartments in ${cityName}`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Kamernet is the best site to find apartments in ${cityName} offering verified local listings with maps and photos.
        Explore a range of rental apartments in ${cityName} and easily register to contact landlords directly!
        You can either secure your desired ${cityName} apartment online by contacting the landlord or your future housemate,
        or you can also schedule an in-person viewing. With Kamernet, you can enjoy a secure and hassle-free rental experience of finding your ideal flat and apartment in ${cityName} today.`}
      </Typography>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <Typography variant="h1" className={styles.title}>
        {`Appartementen en flats te huur in ${cityName}, Nederland`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Op zoek naar een appartement in ${cityName}? Kamernet heeft een breed aanbod aan geverifieerde huurappartementen in ${cityName} beschikbaar voor jou.
        Onze database van huurappartementen in ${cityName} is gratis toegankelijk. Meld je aan op Kamernet en vind een huurwoning die past binnen jouw budget en voorkeuren.
        Kamernet is een toonaangevend platform dat huurders zo snel en eenvoudig mogelijk helpt bij het vinden van hun accommodatie.
        Ben je op zoek naar een gemeubileerd appartement in ${cityName} dat direct beschikbaar is? Gebruik dan onze geavanceerde zoekopties om het aanbod te filteren op specifieke kenmerken.`}
      </Typography>
      <Typography variant="h3" component="h2" className={styles.title}>
        {`Appartementen in ${cityName} vinden als expat`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Als expat die naar ${cityName} verhuist, is het slim om enkele maanden van tevoren te beginnen met het zoeken naar huurappartementen in ${cityName}.
        Op Kamernet vind je eenvoudig beschikbare appartementen in ${cityName} die zijn afgestemd op jouw specifieke wensen.
        Of je nu op zoek bent naar een appartement met 1 slaapkamer, 2 slaapkamers, semi-gemeubileerd, volledig gemeubileerd, privé of gedeeld, lange termijn of korte termijn in ${cityName}.
        Kamernet heeft alles wat je nodig hebt. Met onze slimme zoekfilters vind je snel de perfecte plek in ${cityName}, inclusief al jouw gewenste voorzieningen.`}
      </Typography>
      <Typography variant="h3" component="h2" className={styles.title}>
        {`Beste website om appartementen te vinden in ${cityName}`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Kamernet is de beste website om appartementen te vinden in ${cityName}, met geverifieerde lokale advertenties, inclusief kaarten en foto's.
        Verken het aanbod van huurappartementen in ${cityName} en registreer je eenvoudig om rechtstreeks contact op te nemen met de verhuurder!
        Je kunt jouw gewenste appartement in ${cityName} online vastleggen door contact op te nemen met de verhuurder of je toekomstige huisgenoot, of je kunt een bezichtiging inplannen.
        Met Kamernet geniet je van een veilige en zorgeloze huurervaring bij het vinden van jouw ideale flat of appartement in ${cityName}. Begin vandaag nog met zoeken.`}
      </Typography>
    </React.Fragment>
  );
};
